<template>
  <div
    class="owal-progress-bar__container"
  >
    <div
      class="owal-progress-bar__progress-outer"
    >
      <div
        class="owal-progress-bar__progress-inner"
        :style="`width: ${this.percentComplete * 100.0}%`"
      >
        ...
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OwalProgressBar',
  props: {
    /** @prop {Number} percentComplete A number from 0.0 to 1.0 describing the completion state of the progress bar. */
    percentComplete: Number,
  },
}
</script>

<style scoped>
.owal-progress-bar__container {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 1rem;
  transition: height 200ms linear;
}

.owal-progress-bar__container:hover {
  height: 3rem;
}

.owal-progress-bar__progress-outer {
  display: flex;
  flex-shrink: 0;
  flex-grow: 1;
  background: #8492A6;
  height: 1rem;
}

.owal-progress-bar__progress-inner {
  display: flex;
  background: #ABD57C;
  flex-shrink: 0;
  color: #8492A6;
  vertical-align: middle;
  align-items: center;
}
</style>
